//  中文
import zhLocale from 'element-ui/lib/locale/lang/zh-CN'


const zh = {
  // ============== 登陆页 start=============
  "登录": "登录",
  "退出": "退出",
  "账号": "账号",
  "密码": "密码",
  "验证码": "验证码",
  "请输入账号": "请输入账号",
  "请输入密码": "请输入密码",
  "请输入验证码": "请输入验证码",
  "验证码不正确": "验证码不正确",
  "请输入有效的邮箱地址":"请输入有效的邮箱地址",
  "没有账号": "没有账号",
  "请": "请",
  "点击注册": "点击注册",
  // ============== 登陆页 end  =============
  // =========== 首页 start  ==================
  "门店总量": "门店总量",
  "用户总量": "用户总量",
  "营业总量": "营业总量",
  "订单总量": "订单总量",
  "菜品总量": "菜品总量",
  "销售总额": "销售总额",
  "元": "€",
  "预计收入": "预计收入",
  "今日概况": "今日概况",
  "销售额": "销售额",
  "支付订单数": "支付订单数",
  "昨日": "昨日",
  "新增用户数": "新增用户数",
  "新增商户": "新增商户",
  "下单用户数": "下单用户数",
  "待办事项": "待办事项",
  "请尽快处理，以免影响营业": "请尽快处理，以免影响营业",
  "待处理订单": "待处理订单",
  "库存告急": "库存告急",
  "销量": "销量",
  "暂无上榜记录": "暂无上榜记录",
  "成交额": "成交额",
  "成交量": "成交量",
  "退单额": "退单额",
  "退单量": "退单量",
  // =========== 首页 end==================
  // =========== 建店必做 start  =============
  "基本资料": "基本资料",
  "编辑门店": "编辑门店",
  "商家信息": "商家信息",
  "官方网站": "官方网站",
  "门店服务": "门店服务",
  "服务与营业时间": "服务与营业时间",
  "与店内营业时间相同": "与店内营业时间相同",
  "收银台": "收银台",
  "后厨": "后厨",
  "网站": "网站",
  "网站编辑": "网站编辑",
  "上一步": "上一步",
  "保存": "保存",
  "下一步": "下一步",
  "提交失败": "提交失败",
  "获取当前进度信息失败": "获取当前进度信息失败",
  "在地图中点击确认位置，坐标自动填入":"在地图中点击确认位置，坐标自动填入",
  "商家店名": "商家店名",
  "请输入商家店名": "请输入商家店名",
  "请输入门店名称": "请输入门店名称",
  "登录密码": "登录密码",
  "请输入登录密码": "请输入登录密码",
  "确认密码": "确认密码",
  "请输入确认密码": "请输入确认密码",
  "联系人": "联系人",
  "请输入联系人": "请输入联系人",
  "联系电话": "联系电话",
  "请输入联系电话": "请输入联系电话",
  "店铺类型": "店铺类型",
  "分店": "分店",
  "直营": "直营",
  "菜品分类": "菜品分类",
  "同步主店": "同步主店",
  "分店创建": "分店创建",
  "温馨提示：选择后，请勿随意修改，以免造成门店菜品数据错乱": "温馨提示：选择后，请勿随意修改，以免造成门店菜品数据错乱",
  "绑定用户": "绑定用户",
  "选择用户": "选择用户",
  "用户昵称": "用户昵称",
  "选择图片": "选择图片",
  "地址": "地址",
  "请输入地址": "请输入地址",
  "门店坐标": "门店坐标",
  "商家介绍": "商家介绍",
  "状态": "状态",
  "开启": "开启",
  "禁止": "禁止",
  "营业状态": "营业状态",
  "营业中": "营业中",
  "停止营业": "停止营业",
  "上传图片": "上传图片",
  "获取当前门店失败，请刷新界面重试": "获取当前门店失败，请刷新界面重试",
  "商城名称": "商城名称",
  "商城名称不能为空": "商城名称不能为空",
  "网址后缀设置": "网址后缀设置",
  "选填，设置后缀可替换下列网址末尾的数字id，方便记忆": "选填，设置后缀可替换下列网址末尾的数字id，方便记忆",
  "网址设置": "网址设置",
  "访问网址": "访问网址",
  "手机网站": "手机网站",
  "默认": "默认",
  "自定义": "自定义",
  "Pad点餐网站": "Pad点餐网站",
  "收银台网站": "收银台网站",
  "后厨网站": "后厨网站",
  "会员设置": "会员设置",
  "请选择默认头像": "请选择默认头像",
  "手机网站二维码": "手机网站二维码",
  "下载": "下载",
  "营业时间": "营业时间",
  "店内营业时间": "店内营业时间",
  "请选择店内营业时间": "请选择店内营业时间",
  "开始时间": "开始时间",
  "结束时间": "结束时间",
  "选择时间范围": "选择时间范围",
  "自提营业时间": "自提营业时间",
  "请选择自提营业时间": "请选择自提营业时间",
  "外卖营业时间": "外卖营业时间",
  "请选择外卖营业时间": "请选择外卖营业时间",
  "外卖配送": "外卖配送",
  "注": "注",
  "外卖配送方式至少选择一个": "外卖配送方式至少选择一个",
  "店内配置": "店内配置",
  "店内用餐方式至少选择一个": "店内用餐方式至少选择一个",
  "堂食服务": "堂食服务",
  "店内堂食结算模式": "店内堂食结算模式",
  "先结账后用餐": "先结账后用餐",
  "先用餐后结账": "先用餐后结账",
  "收银台桌台清台设置": "收银台桌台清台设置",
  "定时清台": "定时清台",
  "立即清台": "立即清台",
  "开启定时清台后，系统将在设置的时间后自动清除收银台点餐的桌台，此功能仅在餐前付款模式下生效": "开启定时清台后，系统将在设置的时间后自动清除收银台点餐的桌台，此功能仅在餐前付款模式下生效",
  "桌台订单清台设置": "桌台订单清台设置",
  "店内堂食服务费": "店内堂食服务费",
  "按就餐人数收取": "按就餐人数收取",
  "按每桌台收取": "按每桌台收取",
  "请输入服务费": "请输入服务费",
  "位": "位",
  "桌": "桌",
  "店内包装费类型": "店内包装费类型",
  "按菜品收费": "按菜品收费",
  "按单收费": "按单收费",
  "包装费": "包装费",
  "请输入包装费": "请输入包装费",
  "外卖服务": "外卖服务",
  "外卖包装费类型": "外卖包装费类型",
  "外卖配送范围": "外卖配送范围",
  "请输入外卖配送范围": "请输入外卖配送范围",
  "外卖配送费": "外卖配送费",
  "请输入外卖配送费": "请输入外卖配送费",
  "最低消费": "最低消费",
  "请输入最低消费": "请输入最低消费",
  "桌码管理": "桌码管理",
  "添加类型": "添加类型",
  "类型名称": "类型名称",
  "删除": "删除",
  "桌位管理": "桌位管理",
  "最少人数": "最少人数",
  "最多人数": "最多人数",
  "取 消": "取 消",
  "确 定": "确 定",
  "请输入类型名称": "请输入类型名称",
  "排序不能为空": "排序不能为空",
  "排序必须为数字": "排序必须为数字",
  "添加成功": "添加成功",
  "修改类型": "修改类型",
  "修改成功": "修改成功",
  "添加区域": "添加区域",
  "区域名称": "区域名称",
  "修改区域": "修改区域",
  "请输入区域名称": "请输入区域名称",
  "分类名称": "分类名称",
  "编号": "编号",
  "选择区域": "选择区域",
  "请选择": "请选择",
  "选择类型": "选择类型",
  "桌号id": "桌号id",
  "所属区域": "所属区域",
  "桌位类型": "桌位类型",
  "桌位编码": "桌位编码",
  "人数区间": "人数区间",
  "人": "人",
  "二维码": "二维码",
  "桌位编号": "桌位编号",
  "请输入桌位编号": "请输入桌位编号",
  "请选择类型名称": "请选择类型名称",
  "请选择所属区域": "请选择所属区域",
  "添加桌位": "添加桌位",
  "关键词": "关键词",
  "添加收银员": "添加收银员",
  "姓名": "姓名",
  "登录账号": "登录账号",
  "联系方式": "联系方式",
  "收银员管理": "收银员管理",
  "编辑": "编辑",
  "手机号": "手机号",
  "请输入登录账号": "请输入登录账号",
  "长度在6到16个字符": "长度在6到16个字符",
  "两次输入密码不一致！": "两次输入密码不一致！",
  "禁用": "禁用",
  "删除后不可恢复，确认删除该记录吗?": "删除后不可恢复，确认删除该记录吗?",
  "提示": "提示",
  "后厨人员管理": "后厨人员管理",
  "添加后厨人员": "添加后厨人员",
  "添加后厨账号": "添加后厨账号",
  "普通分类": "普通分类",
  "添加分类": "添加分类",
  "图片": "图片",
  "分类排序": "分类排序",
  "税率设置": "税率设置",
  "添加税率": "添加税率",
  "税率分类名称": "税率分类名称",
  "税率": "税率",
  "适用于菜品分类": "适用于菜品分类",
  "未找到相应数据": "未找到相应数据",
  "请输入分类名称": "请输入分类名称",
  "分类排序不能为空": "分类排序不能为空",
  "分类排序必须为数字": "分类排序必须为数字",
  "正在翻译，请稍后": "正在翻译，请稍后",
  "多语言翻译": "多语言翻译",
  "修改分类": "修改分类",
  "翻译": "翻译",
  "分类图片": "分类图片",
  "外卖菜品": "外卖菜品",
  "店内菜品": "店内菜品",
  "菜品管理": "菜品管理",
  "分类管理": "分类管理",
  "上架中": "上架中",
  "下架": "下架",
  "菜品名称": "菜品名称",
  "请输入菜品名称": "请输入菜品名称",
  "添加菜品": "添加菜品",
  "菜品": "菜品",
  "实际销量": "实际销量",
  "库存": "库存",
  "发布时间": "发布时间",
  "销售价": "销售价",
  "下架中": "下架中",
  "强制下架": "强制下架",
  "重新上架": "重新上架",
  "上架": "上架",
  "确认要": "确认要",
  "成功": "成功",
  "删除成功": "删除成功",
  "请先选择一个选项": "请先选择一个选项",
  "正在完成翻译，请稍后操作": "正在完成翻译，请稍后操作",
  "请检查表单的必填项是否全部填写": "请检查表单的必填项是否全部填写",
  "补全成功": "补全成功",
  "主语言选择": "主语言选择",
  "请选择主语言": "请选择主语言",
  "高级设置": "高级设置",
  "取消": "取消",
  "修改": "修改",
  "保存成功": "保存成功",
  "规格": "规格",
  "库存计算方式": "库存计算方式",
  "下单减库存": "下单减库存",
  "特色分类": "特色分类",
  "菜品规格": "菜品规格",
  "单规格": "单规格",
  "多规格": "多规格",
  "此菜品正在参加活动，不能修改规格": "此菜品正在参加活动，不能修改规格",
  "AI魔法创建": "AI魔法创建",
  "通过人工智能技术，可以根据菜品名称自动填写菜品详细信息，如配料、卖点、口味等。": "通过人工智能技术，可以根据菜品名称自动填写菜品详细信息，如配料、卖点、口味等。",
  "所属分类": "所属分类",
  "请填写菜品详情": "请填写菜品详情",
  "菜品详情": "菜品详情",
  "换一换": "换一换",
  "请填写菜品价格": "请填写菜品价格",
  "请填写包装费": "请填写包装费",
  "规格明细": "规格明细",
  "规格名称": "规格名称",
  "请输入内容": "请输入内容",
  "价格": "价格",
  "添加规格": "添加规格",
  "菜品图片": "菜品图片",
  "请上传菜品图片": "请上传菜品图片",
  "从AI图库中选择": "从AI图库中选择",
  "使用中文从AI图库搜索": "使用中文从AI图库搜索",
  "AI图库": "AI图库",
  "确认使用": "确认使用",
  "AI未识别到您的菜品图片": "AI未识别到您的菜品图片",
  "可在搜索框": "可在搜索框",
  "更换菜品名称": "更换菜品名称",
  "请输入菜品名称！": "请输入菜品名称！",
  "请在主语言界面上进行操作": "请在主语言界面上进行操作",
  "本菜品正在参加活动，不能删除规格！": "本菜品正在参加活动，不能删除规格！",
  "不能再删除了": "不能再删除了",
  "多语言": "多语言",
  "菜品加料": "菜品加料",
  "添加加料": "添加加料",
  "加料名称": "加料名称",
  "如:杯型": "如:杯型",
  "内容": "内容",
  "积分设置": "积分设置",
  "是否开启积分赠送": "是否开启积分赠送",
  "其他设置": "其他设置",
  "菜品状态": "菜品状态",
  "选择菜品状态": "选择菜品状态",
  "初始销量": "初始销量",
  "菜品排序": "菜品排序",
  "限购数量": "限购数量",
  "每个会员购买的最大数量，0为不限购": "每个会员购买的最大数量，0为不限购",
  "会员折扣设置": "会员折扣设置",
  "是否开启会员折扣": "是否开启会员折扣",
  "默认折扣": "默认折扣",
  "单独设置折扣": "单独设置折扣",
  "默认折扣：默认为用户所属会员等级的折扣率": "默认折扣：默认为用户所属会员等级的折扣率",
  "折扣佣金类型": "折扣佣金类型",
  "百分比": "百分比",
  "固定金额": "固定金额",
  "折扣": "折扣",
  "请输入折扣": "请输入折扣",
  "分销设置": "分销设置",
  "是否开启分销": "是否开启分销",
  "分销规则": "分销规则",
  "平台规则": "平台规则",
  "单独规则": "单独规则",
  "平台规则：层级": "平台规则：层级",
  "1级佣金": "1级佣金",
  "2级佣金": "2级佣金",
  "3级佣金": "3级佣金",
  "分销佣金类型": "分销佣金类型",
  "单独分销设置": "单独分销设置",
  "一级佣金": "一级佣金",
  "二级佣金": "二级佣金",
  "三级佣金": "三级佣金",
  "请填写菜品名称": "请填写菜品名称",
  "你选择菜品分类": "你选择菜品分类",
  "菜品卖点": "菜品卖点",
  "配料": "配料",
  "添加项": "添加项",
  "删除项": "删除项",
  "审核状态": "审核状态",
  "选择审核状态": "选择审核状态",
  "通过": "通过",
  "未通过": "未通过",
  "审核备注": "审核备注",
  "请输入拒绝原因": "请输入拒绝原因",
  "菜品属性": "菜品属性",
  "添加属性": "添加属性",
  "属性名称": "属性名称",
  "属性值": "属性值",
  "至少填写两个": "至少填写两个",
  "如:温度": "如:温度",
  "口味": "口味",
  "菜品同步": "菜品同步",
  "同步至外卖": "同步至外卖",
  "库存数量": "库存数量",
  "请填写库存数量": "请填写库存数量",
  "请上传分类图片": "请上传分类图片",
  "发布": "发布",
  "级": "级",
  "请填写口味": "请填写口味",
  "从AI图库搜索": "从AI图库搜索",
  "AI获取标签": "AI获取标签",
  "标签": "标签",
  "添加的标签可以帮助AI点餐助手更准确地理解顾客的点餐需求": "添加的标签可以帮助AI点餐助手更准确地理解顾客的点餐需求",
  "同步至店内": "同步至店内",
  "是否同步菜品至外卖": "是否同步菜品至外卖",
  "是否同步菜品至店内": "是否同步菜品至店内",
  "付款减库存": "付款减库存",
  "菜品录入使用语言": "菜品录入使用语言",
  "网站主页": "网站主页",
  "主题编辑": "主题编辑",
  "我的菜单": "我的菜单",
  "添加菜单": "添加菜单",
  "菜单名称": "菜单名称",
  "图标": "图标",
  "是否显示": "是否显示",
  "添加时间": "添加时间",
  "更新时间": "更新时间",
  "操作": "操作",
  "正在处理": "正在处理",
  "处理失败，请重试": "处理失败，请重试",
  "此操作将永久删除该记录, 是否继续?": "此操作将永久删除该记录, 是否继续?",
  "确定": "确定",
  "主题选择": "主题选择",
  "主题一": "主题一",
  "主题二": "主题二",
  "主题三": "主题三",
  "主题四": "主题四",
  "主题五": "主题五",
  "主题六": "主题六",
  "主页预览": "主页预览",
  "撤回": "撤回",
  "获取预览网站失败,请检查网络或联系管理员": "获取预览网站失败,请检查网络或联系管理员",
  "撤回成功": "撤回成功",
  "编辑菜单": "编辑菜单",
  "请输入广告标题": "请输入广告标题",
  "图标大小为": "图标大小为",
  "显示": "显示",
  "隐藏": "隐藏",
  "请输入数字": "请输入数字",
  "链接": "链接",
  "选择链接": "选择链接",
  "提交": "提交",
  "请输入菜单名称": "请输入菜单名称",
  "请选择链接地址": "请选择链接地址",
  "链接到": "链接到",
  "请上传图标": "请上传图标",
  "确定要删除吗?": "确定要删除吗?",
  "次浏览": "次浏览",
  "每日必拼": "每日必拼",
  "更多": "更多",
  "2人团": "2人团",
  "去开团": "去开团",
  "活动砍价": "活动砍价",
  "已抢2件": "已抢2件",
  "立即砍价": "立即砍价",
  "满": "满",
  "可用": "可用",
  "立即领取": "立即领取",
  "热门直播": "热门直播",
  "已售": "已售",
  "限时秒杀": "限时秒杀",
  "搜索菜品": "搜索菜品",
  "线下门店": "线下门店",
  "门店logo": "门店logo",
  "门店地址": "门店地址",
  "您的浏览器不支持 video 标签": "您的浏览器不支持 video 标签",
  "店家正在直播、折扣套餐秒杀中": "店家正在直播、折扣套餐秒杀中",
  "进入": "进入",
  "至少保留一个": "至少保留一个",
  "咨询分类": "咨询分类",
  "全部分类": "全部分类",
  "显示数量": "显示数量",
  "咨询数据请到": "咨询数据请到",
  "插件": "插件",
  "通告": "通告",
  "显示类型": "显示类型",
  "有图模式": "有图模式",
  "无图模式": "无图模式",
  "组件样式": "组件样式",
  "显示内容": "显示内容",
  "拼团价格": "拼团价格",
  "划线价格": "划线价格",
  "指示点颜色": "指示点颜色",
  "重置": "重置",
  "切换时间": "切换时间",
  "轮播图自动切换的间隔时间，单位：毫秒": "轮播图自动切换的间隔时间，单位：毫秒",
  "链接地址": "链接地址",
  "添加一个": "添加一个",
  "标题内容": "标题内容",
  "文字内容": "文字内容",
  "链接名称": "链接名称",
  "正在砍价": "正在砍价",
  "菜品原价": "菜品原价",
  "背景颜色": "背景颜色",
  "组件高度": "组件高度",
  "上下边距": "上下边距",
  "线条样式": "线条样式",
  "实线": "实线",
  "虚线": "虚线",
  "点状": "点状",
  "线条颜色": "线条颜色",
  "线条高度": "线条高度",
  "左右边距": "左右边距",
  "标题": "标题",
  "颜色": "颜色",
  "每行数量": "每行数量",
  "1个": "1个",
  "2个": "2个",
  "文字颜色": "文字颜色",
  "公告图标": "公告图标",
  "公告内容": "公告内容",
  "菜品来源": "菜品来源",
  "自动获取": "自动获取",
  "手动选择": "手动选择",
  "综合": "综合",
  "菜品列表": "菜品列表",
  "列表平铺": "列表平铺",
  "横向滑动": "横向滑动",
  "分列数量": "分列数量",
  "单列": "单列",
  "两列": "两列",
  "三列": "三列",
  "菜品价格": "菜品价格",
  "菜品销量": "菜品销量",
  "提示文字": "提示文字",
  "搜索框样式": "搜索框样式",
  "方形": "方形",
  "圆角": "圆角",
  "圆弧": "圆弧",
  "文字对齐": "文字对齐",
  "居左": "居左",
  "居中": "居中",
  "居右": "居右",
  "秒杀价格": "秒杀价格",
  "底边距": "底边距",
  "右边距": "右边距",
  "不透明度": "不透明度",
  "客服类型": "客服类型",
  "在线聊天": "在线聊天",
  "拨打电话": "拨打电话",
  "电话号码": "电话号码",
  "客服图标": "客服图标",
  "标题类型": "标题类型",
  "页面名称": "页面名称",
  "页面名称仅用于后台查找": "页面名称仅用于后台查找",
  "分享标题": "分享标题",
  "小程序端转发时显示的标题": "小程序端转发时显示的标题",
  "文章数据请到": "文章数据请到",
  "内容管理": "内容管理",
  "文章列表": "文章列表",
  "中管理": "中管理",
  "单行": "单行",
  "两行": "两行",
  "门店列表": "门店列表",
  "选择门店": "选择门店",
  "展示数量": "展示数量",
  "视频高度": "视频高度",
  "滑块可用左右方向键精确调整": "滑块可用左右方向键精确调整",
  "视频封面": "视频封面",
  "视频地址": "视频地址",
  "自动播放": "自动播放",
  "布局方式": "布局方式",
  "堆积两列": "堆积两列",
  "堆积三列": "堆积三列",
  "堆积四列": "堆积四列",
  "橱窗样式": "橱窗样式",
  "橱窗样式最多显示四张图片，超出隐藏": "橱窗样式最多显示四张图片，超出隐藏",
  "请确保所有图片的尺寸/比例相同": "请确保所有图片的尺寸/比例相同",
  "标题文字": "标题文字",
  "组件库": "组件库",
  "媒体组件": "媒体组件",
  "商城组件": "商城组件",
  "工具组件": "工具组件",
  "登录组件": "登录组件",
  "通告管理": "通告管理",
  "添加通告": "添加通告",
  "通告ID": "通告ID",
  "封面": "封面",
  "通告标题": "通告标题",
  "虚拟阅读量": "虚拟阅读量",
  "实际阅读量": "实际阅读量",
  "通告排序": "通告排序",
  "已取消删除": "已取消删除",
  "请输入文章标题": "请输入文章标题",
  "描述": "描述",
  "请输入文章描述": "请输入文章描述",
  "缩略图": "缩略图",
  "通告分类": "通告分类",
  "通告状态": "通告状态",
  "通告内容": "通告内容",
  "分类ID": "分类ID",
  "编辑分类": "编辑分类",
  "恭喜你，修改成功": "恭喜你，修改成功",
  "编辑通告": "编辑通告",
  "份": "份",
  "中文": "中文",
  "英语": "英语",
  "意大利语": "意大利语",
  "德语": "德语",
  "西班牙语": "西班牙语",
  "法语": "法语",
  "克罗地亚": "克罗地亚",
  "斯洛文尼亚": "斯洛文尼亚",
  "匈牙利语": "匈牙利语",
  "规格库": "规格库",
  "属性库": "属性库",
  "加料库": "加料库",
  "规格名": "规格名",
  "批量删除": "批量删除",
  "请输入规格名称": "请输入规格名称",
  "删除后不可恢复，确认删除吗?": "删除后不可恢复，确认删除吗?",
  "属性名": "属性名",
  "请输入属性名称": "请输入属性名称",
  "请输入属性值": "请输入属性值",
  "添加属性名": "添加属性名",
  "AI助理形象选择": "AI助理形象选择",
  // =========== 建店必做 end ==================

  // ================ 订单 start ================
  "实时概况": "实时概况",
  "营业总额": "营业总额",
  "有效订单": "有效订单",
  "退款金额": "退款金额",
  "销量排行榜": "销量排行榜",
  "销售额排行榜": "销售额排行榜",
  "菜品排行榜": "菜品排行榜",
  "订单号": "订单号",
  "请输入订单号": "请输入订单号",
  "起始时间": "起始时间",
  "至": "至",
  "开始日期": "开始日期",
  "结束日期": "结束日期",
  "查询": "查询",
  "导出": "导出",
  "全部订单": "全部订单",
  "未付款": "未付款",
  "进行中": "进行中",
  "已完成": "已完成",
  "订单信息": "订单信息",
  "下单时间": "下单时间",
  "取消申请中": "取消申请中",
  "实付款": "实付款",
  "含服务费": "含服务费",
  "含包装费": "含包装费",
  "买家": "买家",
  "门店名称": "门店名称",
  "出餐状态": "出餐状态",
  "准备中": "准备中",
  "出餐中": "出餐中",
  "待取餐": "待取餐",
  "交易状态": "交易状态",
  "支付方式": "支付方式",
  "配送方式": "配送方式",
  "订单详情": "订单详情",
  "出餐": "出餐",
  "退款": "退款",
  "核销": "核销",
  "确定要出餐吗?": "确定要出餐吗?",
  "确定要核销吗?": "确定要核销吗?",
  "恭喜你，操作成功": "恭喜你，操作成功",
  "已取消核销": "已取消核销",
  "基本信息": "基本信息",
  "订单来源": "订单来源",
  "订单金额": "订单金额",
  "配送费": "配送费",
  "服务费": "服务费",
  "优惠券抵扣": "优惠券抵扣",
  "积分抵扣": "积分抵扣",
  "满减金额": "满减金额",
  "优惠金额": "优惠金额",
  "实付款金额": "实付款金额",
  "用餐方式": "用餐方式",
  "取餐时间": "取餐时间",
  "桌号": "桌号",
  "修改价格": "修改价格",
  "门店信息": "门店信息",
  "菜品信息": "菜品信息",
  "会员折扣价": "会员折扣价",
  "购买数量": "购买数量",
  "菜品总价": "菜品总价",
  "收货信息": "收货信息",
  "收货人": "收货人",
  "收货电话": "收货电话",
  "收货地址": "收货地址",
  "备注": "备注",
  "自提用户信息": "自提用户信息",
  "用户信息": "用户信息",
  "联系手机": "联系手机",
  "付款信息": "付款信息",
  "应付款金额": "应付款金额",
  "支付流水号": "支付流水号",
  "付款状态": "付款状态",
  "付款时间": "付款时间",
  "发货信息": "发货信息",
  "发货状态": "发货状态",
  "取消信息": "取消信息",
  "商家备注": "商家备注",
  "门店自提核销": "门店自提核销",
  "核销员": "核销员",
  "核销状态": "核销状态",
  "已核销": "已核销",
  "核销时间": "核销时间",
  "返回上一页": "返回上一页",
  "确认发货": "确认发货",
  "确认审核": "确认审核",
  "请选择物流公司": "请选择物流公司",
  "请填写物流单号": "请填写物流单号",
  "恭喜你，发货成功": "恭喜你，发货成功",
  "恭喜你，审核成功": "恭喜你，审核成功",
  "订单价格修改": "订单价格修改",
  "运费金额": "运费金额",
  "最终付款价": "最终付款价",
  "取消订单": "取消订单",
  "请输入备注": "请输入备注",
  "请输入退款金额": "请输入退款金额",
  "确认退款?": "确认退款?",
  "已取消退款": "已取消退款",
  "含配送费": "含配送费",
  "确认送达": "确认送达",
  "是否确认此操作?": "是否确认此操作?",
  "配送状态": "配送状态",
  "备注信息": "备注信息",
  "期望配送时间": "期望配送时间",
  "订单状态": "订单状态",
  "骑手姓名": "骑手姓名",
  "骑手电话": "骑手电话",
  "操作时间": "操作时间",
  "详情": "详情",
  "此操作将确认送达, 是否继续?": "此操作将确认送达, 是否继续?",
  "配送时间": "配送时间",
  "配送信息": "配送信息",
  "配送类型": "配送类型",
  "配送距离": "配送距离",
  "配送电话": "配送电话",
  "配送费用": "配送费用",
  "送达时间": "送达时间",
  "取消原因": "取消原因",
  "请输入取消原因": "请输入取消原因",
  "米": "米",
  // ================ 订单 end  ================

  // ================= 门店 start ==============
  "门店ID": "门店ID",
  "联系地址": "联系地址",
  "下载二维码": "下载二维码",
  "H5网页": "H5网页",
  "添加门店": "添加门店",
  "设置": "设置",
  "恭喜你，门店删除成功": "恭喜你，门店删除成功",
  "请输入地点": "请输入地点",
  "添加": "添加",
  "等级": "等级",
  "请选择会员等级": "请选择会员等级",
  "请选择性别": "请选择性别",
  "微信昵称": "微信昵称",
  "请输入微信昵称": "请输入微信昵称",
  "微信头像": "微信头像",
  "昵称": "昵称",
  "用户余额": "用户余额",
  "累积消费金额": "累积消费金额",
  "性别": "性别",
  "注册时间": "注册时间",
  "请按实际店名填写，将显示在商家点餐网站上": "请按实际店名填写，将显示在商家点餐网站上",
  "分钟后自动清理桌台": "分钟后自动清理桌台",
  "首次添加桌位请先添加桌位类型": "首次添加桌位请先添加桌位类型",
  "首次添加桌位请先添加区域": "首次添加桌位请先添加区域",
  "设置店内区域，如A区、B区、大厅、包厢等": "设置店内区域，如A区、B区、大厅、包厢等",
  "设置桌位类型，如二人桌、四人桌、大桌、小桌等": "设置桌位类型，如二人桌、四人桌、大桌、小桌等",
  "扫桌码点餐和收银桌台点餐定时清台时间": "扫桌码点餐和收银桌台点餐定时清台时间",
  "该账号用于登录收银台网站（可在“网址设置”页面找到收银台网址）": "该账号用于登录收银台网站（可在“网址设置”页面找到收银台网址）",
  "该账号用于登录后厨网站（可在“网址设置”页面找到后厨网址）": "该账号用于登录后厨网站（可在“网址设置”页面找到后厨网址）",
  "到店自提": "到店自提",
  "打包带走": "打包带走",
  "如无需设置税率可不填写": "如无需设置税率可不填写",
  "店内就餐": "店内就餐",
  "外卖配送至少选择一种！": "外卖配送至少选择一种！",
  "店内配置至少选择一种！": "店内配置至少选择一种！",
  "恭喜你，设置成功": "恭喜你，设置成功",
  "恭喜你，门店修改成功": "恭喜你，门店修改成功",
  "门店": "门店",
  "提现金额": "提现金额",
  "打款方式": "打款方式",
  "打款信息": "打款信息",
  "开户行": "开户行",
  "待审核": "待审核",
  "审核通过": "审核通过",
  "驳回": "驳回",
  "原因": "原因",
  "已打款": "已打款",
  "审核": "审核",
  "确认打款": "确认打款",
  "确认要打款吗?": "确认要打款吗?",
  "供应商名称": "供应商名称",
  "余额变动场景": "余额变动场景",
  "收入": "收入",
  "提现": "提现",
  "起始日期": "起始日期",
  "变动金额": "变动金额",
  "描述/说明": "描述/说明",
  "创建时间": "创建时间",
  "恭喜你，门店添加成功": "恭喜你，门店添加成功",
  "驳回原因": "驳回原因",
  "提现审核": "提现审核",
  "小票打印设置": "小票打印设置",
  "是否开启商户小票打印": "是否开启商户小票打印",
  "选择打印机": "选择打印机",
  "是否开启顾客小票打印": "是否开启顾客小票打印",
  "选择打印机二": "选择打印机二",
  "是否开启厨房小票打印": "是否开启厨房小票打印",
  "选择打印机三": "选择打印机三",
  "恭喜你，打印设置成功": "恭喜你，打印设置成功",
  "小票打印机列表": "小票打印机列表",
  "打印机ID": "打印机ID",
  "打印机名称": "打印机名称",
  "编辑小票打印机": "编辑小票打印机",
  "打印机类型": "打印机类型",
  "米泰打印机": "米泰打印机",
  "打印机编号": "打印机编号",
  "打印机编号为9位数字，查看米泰打印机底部贴纸上面的编号": "打印机编号为9位数字，查看米泰打印机底部贴纸上面的编号",
  "打印机秘钥": "打印机秘钥",
  "打印联数": "打印联数",
  "同一订单，打印的次数": "同一订单，打印的次数",
  "排序": "排序",
  "数字越小越靠前": "数字越小越靠前",
  "新增小票打印机": "新增小票打印机",
  "恭喜你，添加成功": "恭喜你，添加成功",
  "配送方式设置": "配送方式设置",
  "商家配送": "商家配送",
  "自动配送时间(分钟)": "自动配送时间(分钟)",
  "设置0不自动配送，下单后未配送，设置时间后自动操作配送": "设置0不自动配送，下单后未配送，设置时间后自动操作配送",
  "商户编号": "商户编号",
  "门店编号": "门店编号",
  "环境": "环境",
  "测试环境": "测试环境",
  "正式环境": "正式环境",
  "回调地址": "回调地址",
  "运营城市": "运营城市",
  "恭喜你，上传设置成功": "恭喜你，上传设置成功",
  "分单打印列表": "分单打印列表",
  "名称": "名称",
  "打印类型": "打印类型",
  "外卖": "外卖",
  "店内": "店内",
  "菜品打印": "菜品打印",
  "是否开启": "是否开启",
  "配送打印": "配送打印",
  "店内打印": "店内打印",
  "打印方式": "打印方式",
  "付款打印": "付款打印",
  "下单打印": "下单打印",
  "菜品分组": "菜品分组",
  "男": "男",
  "女": "女",
  "未知": "未知",
  "文件管理": "文件管理",
  "移动至": "移动至",
  "点击上传": "点击上传",
  "删除失败": "删除失败",
  "请选择文件": "请选择文件",
  "确定移动选中的文件吗？, 是否继续?": "确定移动选中的文件吗？, 是否继续?",
  "只能上传图片！": "只能上传图片！",
  "上传文件只能是图片格式!": "上传文件只能是图片格式!",
  "上传文件大小不能超过 2MB!": "上传文件大小不能超过 2MB!",
  "请查看/裁切其它上传图片!": "请查看/裁切其它上传图片!",
  "图片上传中,请等待": "图片上传中,请等待",
  "当前图片上传失败!": "当前图片上传失败!",
  "本次上传图片失败": "本次上传图片失败",
  "本次最多只能上传1个文件": "本次最多只能上传1个文件",
  "裁剪图片": "裁剪图片",
  "选择优惠券": "选择优惠券",
  "数量": "数量",
  "无限制": "无限制",
  "请输入等级名称": "请输入等级名称",
  "长度在3到5个字符": "长度在3到5个字符",
  "错了哦，这是一条错误消息": "错了哦，这是一条错误消息",
  "增加税率": "增加税率",
  "税率分类": "税率分类",
  "请输入税率分类": "请输入税率分类",
  "自定义税率分类": "自定义税率分类",
  "自定义名称，仅用于商家自己区分分类，不会展示给顾客": "自定义名称，仅用于商家自己区分分类，不会展示给顾客",
  "请输入税率值": "请输入税率值",
  "单位是": "单位是",
  "适用菜品分类": "适用菜品分类",
  "请选择菜品分类": "请选择菜品分类",
  "修改税率信息": "修改税率信息",
  "分类名称不能为空": "分类名称不能为空",
  "手机网站编辑": "手机网站编辑",
  "恢复初始默认页面": "恢复初始默认页面",
  "通告为手机网站上展示的通知、公告、商家介绍等，“显示”状态时，该篇通告将展示在手机网站上": "通告为手机网站上展示的通知、公告、商家介绍等，“显示”状态时，该篇通告将展示在手机网站上",
  // ================= 门店 end ==============
  // =====================  营销工具start  ==========
  "会员管理": "会员管理",
  "等级管理": "等级管理",
  "余额明细": "余额明细",
  "请输入昵称": "请输入昵称",
  "邮箱": "邮箱",
  "请输入邮箱地址": "请输入邮箱地址",
  "会员等级": "会员等级",
  "全部": "全部",
  "无等级": "无等级",
  "余额": "余额",
  "积分": "积分",
  "生日": "生日",
  "充值": "充值",
  "恭喜你，用户删除成功": "恭喜你，用户删除成功",
  "请选择等级": "请选择等级",
  "管理员备注": "管理员备注",
  "请输入管理员备注": "请输入管理员备注",
  "恭喜你，用户修改成功": "恭喜你，用户修改成功",
  "会员充值": "会员充值",
  "充值余额": "充值余额",
  "当前余额": "当前余额",
  "充值方式": "充值方式",
  "增加": "增加",
  "减少": "减少",
  "最终金额": "最终金额",
  "变更金额": "变更金额",
  "请输入变更金额": "请输入变更金额",
  "添加等级": "添加等级",
  "等级名称": "等级名称",
  "权重": "权重",
  "升级条件": "升级条件",
  "等级权重": "等级权重",
  "请输入等级权重": "请输入等级权重",
  "权重越大，等级越高": "权重越大，等级越高",
  "等级折扣": "等级折扣",
  "请输入等级折扣": "请输入等级折扣",
  "满足以下勾选的其中一个条件，会员自动升级到该等级": "满足以下勾选的其中一个条件，会员自动升级到该等级",
  "累计消费满": "累计消费满",
  "编辑等级": "编辑等级",
  "累计积分满": "累计积分满",
  "推荐人数满": "推荐人数满",
  "恭喜你，等级修改成功": "恭喜你，等级修改成功",
  "个": "个",
  "充值设置": "充值设置",
  "是否开启余额充值": "是否开启余额充值",
  "注：如开启则移动端显示充值按钮，如果小程序没有资质审核不过可不开启": "注：如开启则移动端显示充值按钮，如果小程序没有资质审核不过可不开启",
  "是否开启自定义金额": "是否开启自定义金额",
  "注：如开启则用户可以填写充值金额": "注：如开启则用户可以填写充值金额",
  "最低充值金额": "最低充值金额",
  "注：自定义充值金额最低充值多少€": "注：自定义充值金额最低充值多少€",
  "充值说明": "充值说明",
  "充值套餐": "充值套餐",
  "支付金额": "支付金额",
  "到账数量": "到账数量",
  "充值时间": "充值时间",
  "到账金额": "到账金额",
  "赠送金额": "赠送金额",
  "提现设置": "提现设置",
  "是否开启提现": "是否开启提现",
  "注：如开启则移动端显示余额提现": "注：如开启则移动端显示余额提现",
  "提现比例": "提现比例",
  "注：提现比例请填写数字0~100": "注：提现比例请填写数字0~100",
  "例：提现金额(100.00元) * 提现比例(100%) = 实际到账(100€)": "例：提现金额(100.00元) * 提现比例(100%) = 实际到账(100€)",
  "最低提现金额": "最低提现金额",
  "注：最低提现金额多少元": "注：最低提现金额多少元",
  "请选择状态": "请选择状态",
  "提现方式": "提现方式",
  "请选择提现方式": "请选择提现方式",
  "微信": "微信",
  "支付宝": "支付宝",
  "银行卡": "银行卡",
  "请输入用户ID": "请输入用户ID",
  "请输入昵称/姓名/手机号": "请输入昵称/姓名/手机号",
  "提现信息": "提现信息",
  "支付宝名称": "支付宝名称",
  "支付宝账号": "支付宝账号",
  "银行名称": "银行名称",
  "开户名": "开户名",
  "银行卡号": "银行卡号",
  "申请时间": "申请时间",
  "审核时间": "审核时间",
  "微信付款": "微信付款",
  "该操作 将使用微信支付企业付款到零钱功能，确定打款吗？": "该操作 将使用微信支付企业付款到零钱功能，确定打款吗？",
  "添加充值套餐": "添加充值套餐",
  "套餐名称": "套餐名称",
  "请输入套餐名称": "请输入套餐名称",
  "请输入支付金额": "请输入支付金额",
  "请输入赠送金额": "请输入赠送金额",
  "请输入到账金额": "请输入到账金额",
  "请输入排序": "请输入排序",
  "用户ID": "用户ID",
  "会员卡管理": "会员卡管理",
  "领取记录": "领取记录",
  "删除记录": "删除记录",
  "请输入关键词": "请输入关键词",
  "过期": "过期",
  "有效": "有效",
  "客户信息": "客户信息",
  "会员卡名称": "会员卡名称",
  "有效期": "有效期",
  "折": "折",
  "领取时间": "领取时间",
  "延期": "延期",
  "撤销": "撤销",
  "添加会员卡": "添加会员卡",
  "启用": "启用",
  "关闭": "关闭",
  "月": "月",
  "永久有效": "永久有效",
  "领取数量": "领取数量",
  "发卡": "发卡",
  "领取设置": "领取设置",
  "请检查必填项是否填写完整": "请检查必填项是否填写完整",
  "领取人数": "领取人数",
  "删除时间": "删除时间",
  "请填写有效期": "请填写有效期",
  "有效期限（月），0为永久有效": "有效期限（月），0为永久有效",
  "请填写价格": "请填写价格",
  "用户购买会员卡需要支付的金额，0为用户免费领取": "用户购买会员卡需要支付的金额，0为用户免费领取",
  "使用须知": "使用须知",
  "请填写使用须知": "请填写使用须知",
  "请填写会员卡名称": "请填写会员卡名称",
  "卡片类型": "卡片类型",
  "卡片样式": "卡片样式",
  "请填写排序": "请填写排序",
  "会员权益": "会员权益",
  "无折扣": "无折扣",
  "请填写折扣": "请填写折扣",
  "开卡赠送": "开卡赠送",
  "优惠券": "优惠券",
  "请填写积分数量": "请填写积分数量",
  "请填写余额数量": "请填写余额数量",
  "请填写优惠券": "请填写优惠券",
  "添加优惠券": "添加优惠券",
  "券名称": "券名称",
  "每人领取数量": "每人领取数量",
  "选择优惠券弹出层": "选择优惠券弹出层",
  "您已经选择了十五张优惠券，若要更换请删除其他优惠券！": "您已经选择了十五张优惠券，若要更换请删除其他优惠券！",
  "请填写菜品编码": "请填写菜品编码",
  "菜品划线价": "菜品划线价",
  "请填写菜品划线价": "请填写菜品划线价",
  "菜品重量": "菜品重量",
  "请填写菜品重量": "请填写菜品重量",
  "批量设置": "批量设置",
  "划线价": "划线价",
  "重量": "重量",
  "应用": "应用",
  "规格图片": "规格图片",
  "规格值": "规格值",
  "请输入规格值": "请输入规格值",
  "请填写规则名或规则值": "请填写规则名或规则值",
  "规格值不能为空": "规格值不能为空",
  "卡名称": "卡名称",
  "卡ID": "卡ID",
  "无": "无",
  "选择会员": "选择会员",
  "恭喜你，发卡成功": "恭喜你，发卡成功",
  "副卡数": "副卡数",
  "张": "张",
  "选择日期": "选择日期",
  "签到设置": "签到设置",
  "签到记录": "签到记录",
  "是否开启签到有礼": "是否开启签到有礼",
  "每日签到固定奖励": "每日签到固定奖励",
  "每日签到送": "每日签到送",
  "递增奖励": "递增奖励",
  "有": "有",
  "第二天起递增奖励": "第二天起递增奖励",
  "第": "第",
  "天起不再递增": "天起不再递增",
  "连续签到额外奖励 （达到额外奖励最大天数时，继续签到不会再获得额外奖励，断签后重新开始计算）": "连续签到额外奖励 （达到额外奖励最大天数时，继续签到不会再获得额外奖励，断签后重新开始计算）",
  "额外奖励": "额外奖励",
  "连续签到": "连续签到",
  "请输入连续签到天数": "请输入连续签到天数",
  "积分奖励": "积分奖励",
  "送": "送",
  "请输入连续签到天数的积分": "请输入连续签到天数的积分",
  "规则": "规则",
  "规则说明": "规则说明",
  "请添加至少一项额外奖励！": "请添加至少一项额外奖励！",
  "天数不能为空！": "天数不能为空！",
  "请输入连续签到积分数！": "请输入连续签到积分数！",
  "每日签到送积分有误": "每日签到送积分有误",
  "请输入第二天起递增积分数": "请输入第二天起递增积分数",
  "请输入第几天不再递增": "请输入第几天不再递增",
  "恭喜你，保存成功": "恭喜你，保存成功",
  "连续签到天数": "连续签到天数",
  "不限": "不限",
  "签到时间": "签到时间",
  "时间": "时间",
  "请输入用户昵称": "请输入用户昵称",
  "签到日期": "签到日期",
  "活动奖品": "活动奖品",
  "取号记录": "取号记录",
  "桌号管理": "桌号管理",
  "取号设置": "取号设置",
  "请输入手机号": "请输入手机号",
  "待叫号": "待叫号",
  "就餐号": "就餐号",
  "就餐人数": "就餐人数",
  "桌位名称": "桌位名称",
  "取号时间": "取号时间",
  "待取号": "待取号",
  "已入座": "已入座",
  "已过号": "已过号",
  "是否开启打印": "是否开启打印",
  "须知": "须知",
  "请输入须知": "请输入须知",
  "商家说明": "商家说明",
  "请输入商家说明": "请输入商家说明",
  "取号规则": "取号规则",
  "等待时间": "等待时间",
  "人数最小值": "人数最小值",
  "人数最大值": "人数最大值",
  "等待时间(分钟)": "等待时间(分钟)",
  "请输入桌位名称": "请输入桌位名称",
  "请输入人数最小值": "请输入人数最小值",
  "请输入人数最大值": "请输入人数最大值",
  "请输入等待时间": "请输入等待时间",
  "菜品设置": "菜品设置",
  "兑换记录": "兑换记录",
  "活动名称": "活动名称",
  "请输入活动名称": "请输入活动名称",
  "活动列表": "活动列表",
  "添加活动": "添加活动",
  "活动价格": "活动价格",
  "发放数量": "发放数量",
  "参与人数": "参与人数",
  "终止": "终止",
  "购买记录": "购买记录",
  "新增活动会场": "新增活动会场",
  "活动标题": "活动标题",
  "请输入活动标题": "请输入活动标题",
  "活动日期": "活动日期",
  "礼包设置": "礼包设置",
  "优惠券id": "优惠券id",
  "购买设置": "购买设置",
  "购买金额": "购买金额",
  "会员购买等级": "会员购买等级",
  "指定等级": "指定等级",
  "购买次数": "购买次数",
  "限购": "限购",
  "每人限购": "每人限购",
  "次": "次",
  "发放设置": "发放设置",
  "请输入发放数量": "请输入发放数量",
  "返回": "返回",
  "请勿重复添加": "请勿重复添加",
  "至少选择一个优惠券": "至少选择一个优惠券",
  "新增活动": "新增活动",
  "券包设置": "券包设置",
  "下载推广码": "下载推广码",
  "下载类型": "下载类型",
  "使用该功能前，需前往小程序后台，在“设置”-“接口设置”-“公众号关注组件”中设置要展示的公众号。注：设置的公众号需与小程序主体一致": "使用该功能前，需前往小程序后台，在“设置”-“接口设置”-“公众号关注组件”中设置要展示的公众号。注：设置的公众号需与小程序主体一致",
  "去配置": "去配置",
  "若没有配置公众号，功能将不生效": "若没有配置公众号，功能将不生效",
  "在一个小程序的生命周期内，只有从以下场景进入小程序，才具有展示引导关注公众号的能力": "在一个小程序的生命周期内，只有从以下场景进入小程序，才具有展示引导关注公众号的能力",
  "当小程序从扫小程序码打开时": "当小程序从扫小程序码打开时",
  "当从其他小程序返回小程序时，若小程序之前未被销毁，则该组件保持上一次打开小程序时的状态": "当从其他小程序返回小程序时，若小程序之前未被销毁，则该组件保持上一次打开小程序时的状态",
  "公众号关注": "公众号关注",
  "新客设置": "新客设置",
  "是否开启活动": "是否开启活动",
  "活动时间": "活动时间",
  "背景图": "背景图",
  "赠送优惠券": "赠送优惠券",
  "请选择优惠券": "请选择优惠券",
  "赠送积分": "赠送积分",
  "请输入赠送积分": "请输入赠送积分",
  "直播同步": "直播同步",
  "同步直播": "同步直播",
  "请输入直播间名称/主播昵称": "请输入直播间名称/主播昵称",
  "直播间ID": "直播间ID",
  "直播间名称": "直播间名称",
  "主播昵称": "主播昵称",
  "直播开始时间": "直播开始时间",
  "直播结束时间": "直播结束时间",
  "直播间状态": "直播间状态",
  "置顶": "置顶",
  "未置顶": "未置顶",
  "已置顶": "已置顶",
  "设为置顶": "设为置顶",
  "取消置顶": "取消置顶",
  "直播中": "直播中",
  "未开始": "未开始",
  "已结束": "已结束",
  "禁播": "禁播",
  "暂停": "暂停",
  "异常": "异常",
  "已过期": "已过期",
  "置顶成功": "置顶成功",
  "邀请活动": "邀请活动",
  "个人中心图片": "个人中心图片",
  "请输入用户昵称/手机号": "请输入用户昵称/手机号",
  "邀请人": "邀请人",
  "被邀请人": "被邀请人",
  "参加时间": "参加时间",
  "个人中心显示": "个人中心显示",
  "参与记录": "参与记录",
  "礼品记录": "礼品记录",
  "推广二维码": "推广二维码",
  "编辑活动会场": "编辑活动会场",
  "请输入分享标题": "请输入分享标题",
  "请输入分享内容": "请输入分享内容",
  "分享内容": "分享内容",
  "分享图": "分享图",
  "个人中心状态": "个人中心状态",
  "邀请成功的条件": "邀请成功的条件",
  "邀请成为会员": "邀请成为会员",
  "邀请成为会员且消费": "邀请成为会员且消费",
  "礼品设置": "礼品设置",
  "奖项": "奖项",
  "每邀请": "每邀请",
  "人获得礼品": "人获得礼品",
  "添加奖励项": "添加奖励项",
  "请上传背景图": "请上传背景图",
  "请上传分享图": "请上传分享图",
  "请添加奖项": "请添加奖项",
  "开启首页推送": "开启首页推送",
  "建议换活动，此名称更换，商城首页弹窗根据此名称不同来弹窗": "建议换活动，此名称更换，商城首页弹窗根据此名称不同来弹窗",
  "类型": "类型",
  "图文": "图文",
  "纯图": "纯图",
  "领取优惠券": "领取优惠券",
  "请输入标题": "请输入标题",
  "弹窗图片": "弹窗图片",
  "图片为2M以内大小，格式限png，jpg格式": "图片为2M以内大小，格式限png，jpg格式",
  "建议尺寸": "建议尺寸",
  "按钮文案": "按钮文案",
  "简介说明": "简介说明",
  "请输入说明": "请输入说明",
  "点击选择你要链接的位置": "点击选择你要链接的位置",
  "跳转地址": "跳转地址",
  "最多可以添加三张": "最多可以添加三张",
  "最多添加3张优惠券": "最多添加3张优惠券",
  "标题不能为空": "标题不能为空",
  "请选择跳转链接": "请选择跳转链接",
  "请选择优惠卷": "请选择优惠卷",
  "请上传图片": "请上传图片",
  "团购订单": "团购订单",
  "团购管理": "团购管理",
  "团购设置": "团购设置",
  "订单设置": "订单设置",
  "未支付订单": "未支付订单",
  "请输入关闭时间": "请输入关闭时间",
  "团购保障": "团购保障",
  "使用门店": "使用门店",
  "待付款": "待付款",
  "待使用": "待使用",
  "已取消": "已取消",
  "已退款": "已退款",
  "使用门店名称": "使用门店名称",
  "门店联系人": "门店联系人",
  "门店电话": "门店电话",
  "团购信息": "团购信息",
  "券码信息": "券码信息",
  "核销券码": "核销券码",
  "添加团购": "添加团购",
  "团购名称": "团购名称",
  "销售价格": "销售价格",
  "虚拟销量": "虚拟销量",
  "部分": "部分",
  "基础设置": "基础设置",
  "购买须知": "购买须知",
  "团购详情": "团购详情",
  "团购须知": "团购须知",
  "请输入团购名称": "请输入团购名称",
  "到期类型": "到期类型",
  "购买后生效": "购买后生效",
  "固定时间": "固定时间",
  "有效天数": "有效天数",
  "请输入有效天数": "请输入有效天数",
  "有效时间": "有效时间",
  "请输入有效时间": "请输入有效时间",
  "团购图片": "团购图片",
  "请上传团购图片": "请上传团购图片",
  "请输入划线价格": "请输入划线价格",
  "请输入销售价格": "请输入销售价格",
  "请输入虚拟销量": "请输入虚拟销量",
  "适用门店": "适用门店",
  "请选择门店": "请选择门店",
  "团购状态": "团购状态",
  "每日限购数量": "每日限购数量",
  "每个会员每日购买的最大数量，0为不限购": "每个会员每日购买的最大数量，0为不限购",
  "商家名称": "商家名称",
  "平台": "平台",
  "满类型": "满类型",
  "满额": "满额",
  "满件数": "满件数",
  "满值": "满值",
  "减类型": "减类型",
  "减金额": "减金额",
  "打折": "打折",
  "减值": "减值",
  "编辑活动": "编辑活动",
  "满金额": "满金额",
  "请输入满值": "请输入满值",
  "如果是打折，填写80，表示打8折": "如果是打折，填写80，表示打8折",
  "满额免配送费设置": "满额免配送费设置",
  "是否开启满额免配送费": "是否开启满额免配送费",
  "单笔订单满": "单笔订单满",
  "如果开启满额免配送费，设置0为全场免配送费": "如果开启满额免配送费，设置0为全场免配送费",
  "入驻申请": "入驻申请",
  "配送员": "配送员",
  "配送订单": "配送订单",
  "提现申请": "提现申请",
  "配送设置": "配送设置",
  "退出申请": "退出申请",
  "正常": "正常",
  "押金": "押金",
  "累计佣金": "累计佣金",
  "可提现佣金": "可提现佣金",
  "已提现佣金": "已提现佣金",
  "提现明细": "提现明细",
  "申请条件": "申请条件",
  "结算": "结算",
  "是否开启押金支付": "是否开启押金支付",
  "是否审核": "是否审核",
  "需后台审核": "需后台审核",
  "无需审核": "无需审核",
  "菜品列表弹出层": "菜品列表弹出层",
  "已选择该菜品": "已选择该菜品",
  "注：如使用微信支付，则需申请微信支付企业付款到零钱功能": "注：如使用微信支付，则需申请微信支付企业付款到零钱功能",
  "微信提现方式": "微信提现方式",
  "微信提现到零钱": "微信提现到零钱",
  "商家转账到零钱": "商家转账到零钱",
  "注：根据实际菜品开通情况选择": "注：根据实际菜品开通情况选择",
  "最低提现额度": "最低提现额度",
  "佣金结算时间": "佣金结算时间",
  "注：当订单完成n小时后，该订单的配送佣金才会结算到配送员余额，如果设置为0小时，则订单完成时就结算": "注：当订单完成n小时后，该订单的配送佣金才会结算到配送员余额，如果设置为0小时，则订单完成时就结算",
  "请至少选择一种提现方式": "请至少选择一种提现方式",
  "佣金结算": "佣金结算",
  "是否结算佣金": "是否结算佣金",
  "已结算": "已结算",
  "未结算": "未结算",
  "送达状态": "送达状态",
  "查看详情": "查看详情",
  "该操作将使用微信支付企业付款到零钱功能，确定打款吗？": "该操作将使用微信支付企业付款到零钱功能，确定打款吗？",
  "身份证号": "身份证号",
  "待交押金": "待交押金",
  "审核方式": "审核方式",
  "查看": "查看",
  "配送员审核": "配送员审核",
  "添加外卖菜品": "添加外卖菜品",
  "序号": "序号",
  "活动折扣": "活动折扣",
  "活动库存": "活动库存",
  "添加店内菜品": "添加店内菜品",
  "优惠券列表": "优惠券列表",
  "发送优惠券": "发送优惠券",
  "发送对象": "发送对象",
  "全站会员": "全站会员",
  "指定会员": "指定会员",
  "选择会员等级": "选择会员等级",
  "发送的优惠券会员领取已达到限制数量，将不再发送给该会员": "发送的优惠券会员领取已达到限制数量，将不再发送给该会员",
  "发送成功": "发送成功",
  "优惠券ID": "优惠券ID",
  "优惠券名称": "优惠券名称",
  "优惠券类型": "优惠券类型",
  "最低消费金额": "最低消费金额",
  "优惠方式": "优惠方式",
  "立减": "立减",
  "打": "打",
  "领取": "领取",
  "天内有效": "天内有效",
  "发放总数量": "发放总数量",
  "不限制": "不限制",
  "已领取数量": "已领取数量",
  "修改优惠券": "修改优惠券",
  "请输入优惠券名称": "请输入优惠券名称",
  "例如：满100减10": "例如：满100减10",
  "优惠券颜色": "优惠券颜色",
  "蓝色": "蓝色",
  "红色": "红色",
  "紫色": "紫色",
  "黄色": "黄色",
  "满减券": "满减券",
  "折扣券": "折扣券",
  "减免金额": "减免金额",
  "请输入减免金额": "请输入减免金额",
  "折扣率": "折扣率",
  "请输入折扣率": "请输入折扣率",
  "折扣率范围0-10，9.5代表9.5折，0代表不折扣": "折扣率范围0-10，9.5代表9.5折，0代表不折扣",
  "请输入最低消费金额": "请输入最低消费金额",
  "后生效": "后生效",
  "请输入发放总数量": "请输入发放总数量",
  "限制领取的优惠券数量，-1为不限制": "限制领取的优惠券数量，-1为不限制",
  "是否显示在领券中心": "是否显示在领券中心",
  "新用户首次进入小程序的时候才会显示如图所示的弹窗提示，只显示一次": "新用户首次进入小程序的时候才会显示如图所示的弹窗提示，只显示一次",
  "引导收藏": "引导收藏",
  "编辑类型": "编辑类型",
  "生日设置": "生日设置",
  "手机短信": "手机短信",
  "分销商用户": "分销商用户",
  "分销订单": "分销订单",
  "分销海报": "分销海报",
  "推荐人": "推荐人",
  "下级用户": "下级用户",
  "一级": "一级",
  "二级": "二级",
  "三级": "三级",
  "成为时间": "成为时间",
  "下级": "下级",
  "加入时间": "加入时间",
  "分销商条件": "分销商条件",
  "佣金设置": "佣金设置",
  "自定义文字": "自定义文字",
  "申请协议": "申请协议",
  "页面背景图": "页面背景图",
  "分销中心页面": "分销中心页面",
  "页面标题": "页面标题",
  "分销中心": "分销中心",
  "非分销商提示": "非分销商提示",
  "您还不是分销商，请先提交申请": "您还不是分销商，请先提交申请",
  "申请成为分销商": "申请成为分销商",
  "立即加入": "立即加入",
  "可提现": "可提现",
  "待提现佣金": "待提现佣金",
  "待提现": "待提现",
  "已提现金额": "已提现金额",
  "去提现": "去提现",
  "申请成为分销商页面": "申请成为分销商页面",
  "请填写申请信息": "请填写申请信息",
  "分销商申请协议": "分销商申请协议",
  "申请成为经销商": "申请成为经销商",
  "审核中提示信息": "审核中提示信息",
  "您的申请已受理，正在进行信息核验，请耐心等待。": "您的申请已受理，正在进行信息核验，请耐心等待。",
  "去商城逛逛": "去商城逛逛",
  "分销订单页面": "分销订单页面",
  "我的团队页面": "我的团队页面",
  "我的团队": "我的团队",
  "团队总人数": "团队总人数",
  "一级团队": "一级团队",
  "二级团队": "二级团队",
  "三级团队": "三级团队",
  "提现明细页面": "提现明细页面",
  "审核中": "审核中",
  "申请提现页面": "申请提现页面",
  "申请提现": "申请提现",
  "请输入要提取的金额": "请输入要提取的金额",
  "最低提现佣金": "最低提现佣金",
  "提交申请": "提交申请",
  "佣金结算天数": "佣金结算天数",
  "注：当订单完成n天后，该订单的分销佣金才会结算到分销商余额，如果设置为0天,则订单完成时就结算": "注：当订单完成n天后，该订单的分销佣金才会结算到分销商余额，如果设置为0天,则订单完成时就结算",
  "成为分销商条件": "成为分销商条件",
  "购买指定菜品成为分销商": "购买指定菜品成为分销商",
  "购买指定菜品付款后自动成为分销商，无需后台审核": "购买指定菜品付款后自动成为分销商，无需后台审核",
  "选择菜品": "选择菜品",
  "成为下线条件": "成为下线条件",
  "首次点击分享链接": "首次点击分享链接",
  "一级佣金比例": "一级佣金比例",
  "佣金比例范围 0% - 100%": "佣金比例范围 0% - 100%",
  "二级佣金比例": "二级佣金比例",
  "三级佣金比例": "三级佣金比例",
  "是否开启分销功能": "是否开启分销功能",
  "分销层级": "分销层级",
  "一级分销": "一级分销",
  "二级分销": "二级分销",
  "三级分销": "三级分销",
  "分销商内购": "分销商内购",
  "如开启，分销商自己购买菜品，获得一级佣金": "如开启，分销商自己购买菜品，获得一级佣金",
  "分销中心首页": "分销中心首页",
  "尺寸：宽750像素 高度227像素": "尺寸：宽750像素 高度227像素",
  "申请成为分销商页": "申请成为分销商页",
  "申请提现页": "申请提现页",
  "分销海报设置": "分销海报设置",
  "海报背景图": "海报背景图",
  "尺寸：宽750像素 高大于(等于)1200像素": "尺寸：宽750像素 高大于(等于)1200像素",
  "头像宽度": "头像宽度",
  "头像样式": "头像样式",
  "正方形": "正方形",
  "圆形": "圆形",
  "昵称字体大小": "昵称字体大小",
  "昵称字体颜色": "昵称字体颜色",
  "小程序码宽度": "小程序码宽度",
  "小程序码样式": "小程序码样式",
  "分销商": "分销商",
  "一级分销商": "一级分销商",
  "用户": "用户",
  "分销佣金": "分销佣金",
  "二级分销商": "二级分销商",
  "三级分销商": "三级分销商",
  "分销商审核": "分销商审核",
  "积分明细": "积分明细",
  "变动数量": "变动数量",
  "积分名称": "积分名称",
  "例": "例",
  "修改积分名称后，在买家端的所有页面里，看到的都是自定义的名称": "修改积分名称后，在买家端的所有页面里，看到的都是自定义的名称",
  "商家使用自定义的积分名称来做品牌运营。如京东把积分称为“京豆”，淘宝把积分称为“淘金币”": "商家使用自定义的积分名称来做品牌运营。如京东把积分称为“京豆”，淘宝把积分称为“淘金币”",
  "积分说明": "积分说明",
  "积分赠送": "积分赠送",
  "是否开启购物送积分": "是否开启购物送积分",
  "积分赠送规则": "积分赠送规则",
  "如开启则订单完成后赠送用户积分": "如开启则订单完成后赠送用户积分",
  "订单确认收货已完成": "订单确认收货已完成",
  "已完成订单超出后台设置的申请售后期限": "已完成订单超出后台设置的申请售后期限",
  "积分赠送比例": "积分赠送比例",
  "赠送比例请填写数字0~100；订单的运费不参与积分赠送": "赠送比例请填写数字0~100；订单的运费不参与积分赠送",
  "订单付款金额(100.00€) * 积分赠送比例(100%) = 实际赠送的积分(100积分)": "订单付款金额(100.00€) * 积分赠送比例(100%) = 实际赠送的积分(100积分)",
  // =====================  营销工具end   ==========

  // =====================  数据统计 start   ==========
  "销售统计": "销售统计",
  "会员统计": "会员统计",
  "订单概况": "订单概况",
  "菜品概况": "菜品概况",
  "今日": "今日",
  "累积会员数": "累积会员数",
  "新增会员数": "新增会员数",
  "成交会员数": "成交会员数",
  "排行榜": "排行榜",
  "用户消费榜": "用户消费榜",
  "积分排行榜": "积分排行榜",
  "邀请人排行榜": "邀请人排行榜",
  "成交会员占比": "成交会员占比",
  "今天": "今天",
  "最近7天": "最近7天",
  "最近30天": "最近30天",
  "最近90天": "最近90天",
  "最近180天": "最近180天",
  "最近1年": "最近1年",
  "最近2年": "最近2年",
  "所有占比": "所有占比",
  "成交会员": "成交会员",
  "未成交会员": "未成交会员",
  "新增会员": "新增会员",
  "最近一周": "最近一周",
  "最近一个月": "最近一个月",
  "最近三个月": "最近三个月",
  "选择店铺": "选择店铺",
  "查询日期": "查询日期",
  "近七天": "近七天",
  "近十五天": "近十五天",
  "自定义时间": "自定义时间",
  "日期": "日期",
  "有效订单数": "有效订单数",
  "选择时间": "选择时间",
  "交易统计": "交易统计",
  "订单数": "订单数",
  "客单价": "客单价",
  "付款订单": "付款订单",
  "付款人数": "付款人数",
  "菜品统计": "菜品统计",
  "在售菜品": "在售菜品",
  "件": "件",
  "已付款菜品": "已付款菜品",
  "销量TOP10": "销量TOP10",
  "浏览TOP10": "浏览TOP10",
  "浏览": "浏览",
  "排行类型": "排行类型",
  "菜品总数": "菜品总数",
  "已上架菜品": "已上架菜品",
  "已下架菜品": "已下架菜品",
  "菜品导出": "菜品导出",
  "菜品总销量": "菜品总销量",
  "菜品总销售额": "菜品总销售额",
  "资产总览": "资产总览",
  "财务对账": "财务对账",
  "交易记录": "交易记录",
  "店铺结算": "店铺结算",
  "待结算金额": "待结算金额",
  "已结算金额": "已结算金额",
  "交易概况": "交易概况",
  "外卖统计": "外卖统计",
  "店内统计": "店内统计",
  "订单类型": "订单类型",
  "应收金额": "应收金额",
  "实付金额": "实付金额",
  "账户概况": "账户概况",
  "订单编号": "订单编号",
  "支付状态": "支付状态",
  "付款方式": "付款方式",
  "订单费用": "订单费用",
  "优惠": "优惠",
  "商户实际收入": "商户实际收入",
  "菜品ID": "菜品ID",
  "小计": "小计",
  "请输入提现金额": "请输入提现金额",
  "请输入打款方式": "请输入打款方式",
  "支付宝真实姓名": "支付宝真实姓名",
  "请输入支付宝真实姓名": "请输入支付宝真实姓名",
  "开户行名称": "开户行名称",
  "银行开户名": "银行开户名",
  "真实姓名": "真实姓名",
  "应付金额": "应付金额",
  "实付总额": "实付总额",
  "商户": "商户",
  "结算金额": "结算金额",
  "店铺结算金额": "店铺结算金额",
  "操作提示": "操作提示",
  "订单结算金额 = 店铺结算总金额(含运费)": "订单结算金额 = 店铺结算总金额(含运费)",
  "店铺收入金额 = 店铺结算总金额 - 店铺退款金额": "店铺收入金额 = 店铺结算总金额 - 店铺退款金额",
  "订单日期": "订单日期",
  "订单结算金额": "订单结算金额",
  "配送费金额": "配送费金额",
  "菜品编码": "菜品编码",
  "可用余额": "可用余额",
  "提现概况": "提现概况",
  "搜索": "搜索",
  "支出": "支出",
  "金额": "金额",
  "收支类型": "收支类型",
  "确认要退吗?": "确认要退吗?",
  "申请成功": "申请成功",
  "门店总金额": "门店总金额",
  "累计收入": "累计收入",
  "访客数": "访客数",
  "访问量": "访问量",
  "店铺收藏数": "店铺收藏数",
  "菜品收藏数": "菜品收藏数",
  "访问数": "访问数",
  "收藏数": "收藏数",
  "数": "数",
  "待支付": "待支付",
  "实际到账": "实际到账",
  // =====================  数据统计 end   ==========

  // ==================== 设置 start   ================
  "商城设置": "商城设置",
  "物流公司": "物流公司",
  "chatgpt设置": "chatgpt设置",
  "消息设置": "消息设置",
  "短信设置": "短信设置",
  "上传设置": "上传设置",
  "清理缓存": "清理缓存",
  "网址后缀英文名称": "网址后缀英文名称",
  "英文名称": "英文名称",
  "默认头像": "默认头像",
  "英文名称必须只包含数字和英文字母": "英文名称必须只包含数字和英文字母",
  "恭喜你，商城设置成功": "恭喜你，商城设置成功",
  "表单数据不符合规则": "表单数据不符合规则",
  "剩余额度": "剩余额度",
  "余额不足时，智能客服、AI魔法创建、多语言翻译等功能将无法使用": "余额不足时，智能客服、AI魔法创建、多语言翻译等功能将无法使用",
  "使用明细": "使用明细",
  "消费": "消费",
  "额度": "额度",
  "数据缓存": "数据缓存",
  "恭喜你，清理成功": "恭喜你，清理成功",
  "管理员列表": "管理员列表",
  "角色管理": "角色管理",
  "登录日志": "登录日志",
  "操作日志": "操作日志",
  "添加管理员": "添加管理员",
  "管理员ID": "管理员ID",
  "用户名": "用户名",
  "所属角色": "所属角色",
  "超级管理员": "超级管理员",
  "所属门店": "所属门店",
  "门店状态": "门店状态",
  "已删除": "已删除",
  "未删除": "未删除",
  "账号状态": "账号状态",
  "恭喜你，该管理员删除成功": "恭喜你，该管理员删除成功",
  "请输入用户名": "请输入用户名",
  "修改管理员": "修改管理员",
  "添加角色": "添加角色",
  "角色ID": "角色ID",
  "角色名称": "角色名称",
  "恭喜你，该角色删除成功": "恭喜你，该角色删除成功",
  "编辑角色": "编辑角色",
  "请输入角色名称": "请输入角色名称",
  "权限列表": "权限列表",
  "请输入用户名和真实姓名": "请输入用户名和真实姓名",
  "登录状态": "登录状态",
  "全部标记为已读": "全部标记为已读",
  "公告详情": "公告详情",
  "全部标记为已读消息吗?": "全部标记为已读消息吗?",
  "操作成功!": "操作成功!",
  "已取消操作": "已取消操作",
  "订单流程设置": "订单流程设置",
  "已支付订单": "已支付订单",
  "分钟后自动关闭": "分钟后自动关闭",
  "订单下单未付款，n分钟后自动关闭，设置0不自动关闭": "订单下单未付款，n分钟后自动关闭，设置0不自动关闭",
  "分钟后自动核销": "分钟后自动核销",
  "如果在期间未核销，系统自动完成核销，设置0不自动核销": "如果在期间未核销，系统自动完成核销，设置0不自动核销",
  "积分商城订单流程设置": "积分商城订单流程设置",
  "已发货订单": "已发货订单",
  "天后自动核销": "天后自动核销",
  "不包括桌台订单": "不包括桌台订单",
  "恭喜你，交易设置成功": "恭喜你，交易设置成功",
  // ==================== 设置 end ================
  // ==================== Layout start ===========
  "当前版本": "当前版本",
  "试用版": "试用版",
  "专业版": "专业版",
  "高级版": "高级版",
  "至尊版": "至尊版",
  "到期日期": "到期日期",
  "永不过期": "永不过期",
  "欢迎您": "欢迎您",
  "修改密码": "修改密码",
  "此操作将退出登录, 是否继续?": "此操作将退出登录, 是否继续?",
  "原始密码": "原始密码",
  "新密码": "新密码",
  "确认新密码": "确认新密码",
  "系统公告": "系统公告",
  // ==================== Layout end   ==============
  // ==================== Components start   ========
  "请至少选择一件菜品菜品！": "请至少选择一件菜品菜品！",
  "超链接设置": "超链接设置",
  "图像预览": "图像预览",
  "页面": "页面",
  "当前链接": "当前链接",
  "暂无": "暂无",
  "页面路径": "页面路径",
  "注意一": "注意一",
  "注意二": "注意二",
  "注意三": "注意三",
  "同一个小程序链接其他小程序，最多只能链接10个，超过将不生效": "同一个小程序链接其他小程序，最多只能链接10个，超过将不生效",
  "不能填写自身小程序appid": "不能填写自身小程序appid",
  "小程序链接留空默认跳到小程序首页": "小程序链接留空默认跳到小程序首页",
  "分类": "分类",
  "选择": "选择",
  "签到": "签到",
  "积分商城": "积分商城",
  "秒杀": "秒杀",
  "拼团": "拼团",
  "砍价": "砍价",
  "领券中心": "领券中心",
  "生日有礼": "生日有礼",
  "链接的网页必须支持SSL ，链接必须以 https:// 开头，否则无法跳转": "链接的网页必须支持SSL ，链接必须以 https:// 开头，否则无法跳转",
  "链接的域名必须是备案域名，否则无法跳转": "链接的域名必须是备案域名，否则无法跳转",
  "您的网站域名必须加到微信小程序公众平台的业务域名处,详细说明？": "您的网站域名必须加到微信小程序公众平台的业务域名处,详细说明？",
  "选择文章列表": "选择文章列表",
  "文章标题": "文章标题",
  "文章分类": "文章分类",
  "选择规格": "选择规格",
  "菜品/规格": "菜品/规格",
  "已选": "已选",
  "查看物流": "查看物流",
  "请输入收货人": "请输入收货人",
  "请输入收货电话": "请输入收货电话",
  "省": "省",
  "市": "市",
  "区": "区",
  "现金收款": "现金收款",
  "余额收款": "余额收款",
  "其他方式": "其他方式",
  "请输入会员ID号查询会员，输入完毕后点击确认": "请输入会员ID号查询会员，输入完毕后点击确认",
  "请输入会员ID": "请输入会员ID",
  "会员昵称": "会员昵称",
  "余额总计": "余额总计",
  "登录会员仅作为积分累计，无法享受其他优惠": "登录会员仅作为积分累计，无法享受其他优惠",
  "取消收款": "取消收款",
  "收款": "收款",
  "请输入会员手机号": "请输入会员手机号",
  "该用户不存在": "该用户不存在",
  "注册": "注册",
  "平台名称": "平台名称",
  "请输入平台名称": "请输入平台名称",
  "所在地区": "所在地区",
  "请选择所在地区": "请选择所在地区",
  "平台账户名": "平台账户名",
  "请输入平台账户名": "请输入平台账户名",
  "平台账户密码": "平台账户密码",
  "是否连锁": "是否连锁",
  "是": "是",
  "否": "否",
  "请输入您的地址": "请输入您的地址",
  "请输入您的联系电话": "请输入您的联系电话",
  "请输入您的联系邮箱": "请输入您的联系邮箱",
  "联系邮箱": "联系邮箱",
  "不能全是空格": "不能全是空格",
  "不能包含空格": "不能包含空格",
  "长度不能小于6位": "长度不能小于6位",
  "请填写确认密码": "请填写确认密码",
  "确认密码不一致": "确认密码不一致",
  "联系电话和联系邮箱至少填写一个": "联系电话和联系邮箱至少填写一个",
  "注册成功,请前往登录": "注册成功,请前往登录",
  "清空": "清空",
  "确认": "确认",
  "限时免费": "限时免费",
  // ==================== Components end     =========

  // ==================== 其它 start     =============
  "区域管理":"区域管理",
  "点餐管理系统": "点餐管理系统",
  "首页": "首页",
  "余额支付": "余额支付",
  "线下支付(现金支付)": "线下支付(现金支付)",
  "线下支付(自有微信支付)":"线下支付(自有微信支付)",
  "线下支付(自有支付宝支付)":"线下支付(自有支付宝支付)",
  "线下支付(POS刷卡支付)":"线下支付(POS刷卡支付)",
  "待配送":"待配送",
  "配送中":"配送中",
  "待接单":"待接单",
  "待取货":"待取货",
  "已配送":"已配送",
  "已收货":"已收货",
  "待收货":"待收货",
  "待取消":"待取消",
  "会员":"会员",
  "商家":"商家",
  "供应商":"供应商",
  "分销":"分销",
  "通知":"通知",
  "已付款":"已付款",
  "用户下单":"用户下单",
  "收银台下单":"收银台下单",
  "扫码下单":"扫码下单",
  "团购下单":"团购下单",
  "商城订单":"商城订单",
  "积分商城订单":"积分商城订单",
  "余额充值订单":"余额充值订单",
  "购卡订单":"购卡订单",
  "券包订单":"券包订单",
  "配送员押金订单":"配送员押金订单",
  "快递配送":"快递配送",
  "个人中心":"个人中心",
  "添加优惠券请前往'营销工具'—'插件中心'—'优惠券'页面":"添加优惠券请前往“营销工具”—“插件中心”—“优惠券”页面",
  // ==================== 其它 end      ==============
  ...zhLocale
}


export default zh



// WEBPACK FOOTER //
// ./src/i18n/langs/zh.js